import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagFilterActive = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--filter-active', className].filter(Boolean).join(' ')} />
);
